import React from "react";
import { useMutation } from "react-query";
import Axios from "axios";
import {
  antdAsyncMessageError,
  antdAsyncMessageSuccess,
} from "../../../../../helpers/AsyncMessage";
import { Form, Input, Button, Row, Col } from "antd";
import ModalSpecial from "../../../../../components/Layout/Modals/ModalSpecial";
import RangePickerComp from "../../../../../components/common/RangePickerComp";
import SwitchComp from "../../../../../components/common/SwitchComp";
import UploadFormItem from "../UploadFormItem";
import dayjs from "dayjs";
import moment from "moment";

const initialState = {
  check: false,
  desktopImageFile: null,
  desktopImageUrl: null,
  mobileImageFile: null,
  mobielImageUrl: null,
  destinationUrl: null,
  id: null,
};

const ModalNewBanner = ({ onClose, modalOpt, orderShops, bannerData }) => {
  const [form] = Form.useForm();
  const [switches, setSwitches] = React.useState({});
  // console.log(modalOpt.record_id, "modalOpt");
  // console.log(bannerData, "bannerData");
  const hasRun = React.useRef(false);

  React.useEffect(() => {
    if (!hasRun.current) {
      const initialSwitches = {};
      orderShops.forEach((shop) => {
        initialSwitches[shop.label.replace(" ", "")] = {
          ...initialState,
          id: shop.value,
        };
      });
      setSwitches(initialSwitches);
      hasRun.current = true;
    }
  }, [orderShops]);

  const mutation = useMutation({
    mutationFn: (value) => {
      const formData = new FormData();
      formData.append("banner[title]", value.title);
      formData.append("banner[custom_event]", value.custom_event);
      formData.append("banner[sort_order]", value.sort_order);
      formData.append("banner[banner_place]", "landing");
      formData.append("banner[valid_from]", value.validity_period[0]);
      formData.append("banner[valid_to]", value.validity_period[1]);

      Object.entries(switches).forEach(([key, switchData], index) => {
        console.log(switchData, "switchData");
        if (switchData.destinationUrl === null) {
          return;
        }
        const desktopFile = switchData?.desktopImageFile;
        const mobileFile = switchData?.mobileImageFile;
        if (desktopFile) {
          formData.append(
            `banner[banner_shops_attributes][${index}][desktop_file][data]`,
            desktopFile
          );
          formData.append(
            `banner[banner_shops_attributes][${index}][desktop_file][title]`,
            desktopFile.name
          );
        }

        if (mobileFile) {
          formData.append(
            `banner[banner_shops_attributes][${index}][mobile_file][data]`,
            mobileFile
          );
          formData.append(
            `banner[banner_shops_attributes][${index}][mobile_file][title]`,
            mobileFile.name
          );
        }
        formData.append(
          `banner[banner_shops_attributes][${index}][destination_url][]`,
          switchData.destinationUrl
        );
        formData.append(
          `banner[banner_shops_attributes][${index}][active]`,
          switchData.check ? "true" : "false"
        );
        formData.append(
          `banner[banner_shops_attributes][${index}][order_shop_id]`,
          switchData.id
        );
        if (modalOpt.type === "edit_landing_banner") {
          if (switchData.banner_shop_id) {
            formData.append(
              `banner[banner_shops_attributes][${index}][id]`,
              switchData.banner_shop_id
            );
          }
        }
      });

      return Axios[modalOpt.type === "edit_landing_banner" ? "put" : "post"](
        `/api/v1/banners/${modalOpt.type === "edit_landing_banner" ? modalOpt.record_id : ""
        }`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      ).then((res) => res.data);
    },
    onSuccess: () => {
      onClose();
      antdAsyncMessageSuccess({ text: "Successfully created", key: "default" });
    },
    onError: antdAsyncMessageError,
  });

  const handleFileChange = (name, type, file, url) => {
    setSwitches((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        [`${type}ImageFile`]: file,
        [`${type}ImageUrl`]: url,
        [`${type}Image`]: file,
        [`${type}ImageFileTitle`]: file?.name,
      },
    }));
  };

  const handleSwitchChange = (name) => {
    setSwitches((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        check: !prev[name].check,
      },
    }));
  };

  const handleInputChange = (name, type, value) => {
    setSwitches((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        [`${type}`]: value,
      },
    }));
  };

  React.useEffect(() => {
    if (modalOpt.type === "edit_landing_banner") {
      const matchingBanner = bannerData.find(
        (banner) => banner.id === modalOpt.record_id
      );
      console.log(matchingBanner, "matchingBanner");
      if (matchingBanner) {
        form.setFieldsValue({
          title: matchingBanner.title,
          custom_event: matchingBanner.custom_event,
          sort_order: matchingBanner.sort_order,
          validity_period: [
            moment(matchingBanner.valid_from),
            moment(matchingBanner.valid_to),
          ],
        });

        matchingBanner.banner_shops.forEach((shop) => {
          const switchName = shop.order_shop.title?.replace(" ", "");
          console.log(switches, "switches");
          console.log(switches[switchName], "switches[switchName]");
          setSwitches((prev) => {
            if (prev[switchName]) {
              return {
                ...prev,
                [switchName]: {
                  ...prev[switchName],
                  desktopImageUrl: shop.desktop_image,
                  mobielImageUrl: shop.mobile_image,
                  destinationUrl: shop.destination_url,
                  check: shop.active,
                  originalCheck: shop.active,
                  banner_shop_id: shop.id,
                },
              };
            } else {
              return {
                ...prev,
                [switchName]: {
                  desktopImageUrl: shop.desktop_image,
                  mobielImageUrl: shop.mobile_image,
                  destinationUrl: shop.destination_url,
                  check: shop.active,
                  originalCheck: shop.active,
                  banner_shop_id: shop.id,
                },
              };
            }
          });
          form.setFieldsValue({
            [`destination_url_${switchName}`]: shop.destination_url,
          });
        });
      }
    }
  }, [modalOpt, form, bannerData]);

  return (
    <ModalSpecial
      style={{ width: 570 }}
      text={
        <span className="font-bold text-xl text-black">
          {modalOpt.type === "edit_landing_banner" ? "Edit" : "Add"} landing
          banner
        </span>
      }
      onClose={onClose}
    >
      <Form
        form={form}
        layout="vertical"
        name="basic"
        onFinish={(values) => {
          mutation.mutate(values);
        }}
        autoComplete="off"
      >
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: "Can't be empty" }]}
        >
          <Input placeholder="Type in" />
        </Form.Item>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Custom event"
              name="custom_event"
              rules={[{ required: true, message: "Can't be empty" }]}
            >
              <Input placeholder="Type in" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Order in carousel" name="sort_order">
              <Input placeholder="Type in" type="number" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item
          label="Validity period"
          name="validity_period"
          rules={[{ required: true, message: "Can't be empty" }]}
        >
          <RangePickerComp
            style={{ width: "100%" }}
            showTime={{ format: "HH:mm" }}
            placeholder={["Start time", "End time"]}
            disabledDate={() => false}
          />
        </Form.Item>
        <hr className="hr-margin" />
        {Object.keys(switches).map((switchName) => (
          <div key={switchName}>
            <SwitchComp
              className="d-flex flex-row-reverse justify-content-end"
              labelClassName="ml-1"
              label={switchName.slice(0, 2) + " " + switchName.slice(2)}
              checked={switches[switchName].check}
              onChange={() => handleSwitchChange(switchName)}
            />
            {switches[switchName].check && (
              <div>
                <Row gutter={16}>
                  <Col span={12}>
                    <UploadFormItem
                      name={switchName}
                      label="Desktop image"
                      requiredMessage="Please upload an image!"
                      greyText="Recommended .jpeg, .png format and 1200x644"
                      onFileChange={(file, url) =>
                        handleFileChange(switchName, "desktop", file, url)
                      }
                      externalURL={switches[switchName].desktopImageUrl}
                    />
                  </Col>
                  <Col span={12}>
                    <UploadFormItem
                      name={switchName}
                      label="Mobile image"
                      requiredMessage="Please upload an image!"
                      greyText="Recommended .jpeg, .png format and 360x555"
                      onFileChange={(file, url) =>
                        handleFileChange(switchName, "mobile", file, url)
                      }
                      externalURL={switches[switchName].mobielImageUrl}
                    />
                  </Col>
                </Row>
                <Form.Item
                  label="Destination URL"
                  name={`destination_url_${switchName}`}
                  rules={[
                    { required: true, message: "Can't be empty" },
                    () => ({
                      validator(_, value) {
                        const urlPattern = new RegExp(
                          "^(https?:\\/\\/)?" + // protocol
                          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
                          "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
                          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
                          "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
                          "(\\#[-a-z\\d_]*)?$",
                          "i"
                        ); // fragment locator
                        if (!value || urlPattern.test(value)) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Please enter a valid URL")
                        );
                      },
                    }),
                  ]}
                >
                  <Input
                    placeholder="Type in"
                    onChange={(e) =>
                      handleInputChange(
                        switchName,
                        "destinationUrl",
                        e.target.value
                      )
                    }
                  />
                </Form.Item>
              </div>
            )}
            <hr className="hr-margin" />
          </div>
        ))}
        <Form.Item>
          <Button
            className="w-100"
            type="primary"
            htmlType="submit"
            loading={mutation.isLoading}
          >
            {modalOpt.type === "edit_landing_banner" ? "Update" : "Add"}
          </Button>
        </Form.Item>
      </Form>
    </ModalSpecial>
  );
};

export default ModalNewBanner;
